/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Field_IndexInputs */



/**
* | output |
* | --- |
* | "Number ID" |
*
* @param {Transcript_Export_Field_IndexInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_field_index = /** @type {((inputs?: Transcript_Export_Field_IndexInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Field_IndexInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Number ID")
	if (locale === "de") return /** @type {LocalizedString} */ ("Number ID")
	if (locale === "it") return /** @type {LocalizedString} */ ("Number ID")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Number ID")
	if (locale === "es") return /** @type {LocalizedString} */ ("Number ID")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Number ID")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Number ID")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Number ID")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Number ID")
	return /** @type {LocalizedString} */ ("Number ID")
});